import CarePlanViewScreen from './CarePlanViewScreen'
import useFeatureFlags from 'hooks/useFeatureFlags'

export const CarePlanViewScreenWrapper = () => {
  const flags = useFeatureFlags({ flagNames: ['pbs', 'fluid_tracking_intake_targets'] })?.data

  
  const pbsFlagEnabled = flags?.pbs?.enabled ?? false
  const fluidTrackingFlagEnabled = flags?.fluid_tracking_intake_targets?.enabled ?? false

  // @ts-ignore
  return <CarePlanViewScreen pbsFlagEnabled={pbsFlagEnabled} fluidTrackingFlagEnabled={fluidTrackingFlagEnabled}/>
}
